// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__BKhb0","overlay":"Dialog_overlay__12-bh","content":"Dialog_content__1d_on","close":"Dialog_close__2u2U9","icon":"Dialog_icon__3HI6J"};